import { FrameAnchor as FrameAnchorCore } from '@studiometa/ui';

/**
 * Facets component
 */
export default class FrameAnchor extends FrameAnchorCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'FrameAnchor',
    options: {
      collection: String,
    },

  };

  mounted() {
    document.documentElement.style.overflow = '';
    const queryParams = window.location.search;
    if (this.$options.collection == 'true' ) {
      this.$el.href += window.location.search.toString()
    }
  }
}
